module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/panel/panel-border-left-18.png"+" 18w",
        images: [{path: __webpack_public_path__ + "assets/images/panel/panel-border-left-18.png",width: 18,height: 310}],
        src: __webpack_public_path__ + "assets/images/panel/panel-border-left-18.png",
        toString: function(){return __webpack_public_path__ + "assets/images/panel/panel-border-left-18.png"},
        
        width: 18,
        height: 310
      }